// ─────────────────────────────────────────────────────────────
// EXPORTAR SAÍDA DA IA PARA PDF
//
// Sem dependência nova: clona o bloco de saída, monta um cabeçalho
// (título + contexto + data), isola o clone na impressão (o resto da página
// vira display:none) e chama a impressão do navegador. O usuário escolhe
// "Salvar como PDF" e o arquivo sai com TEXTO SELECIONÁVEL e tabelas de
// verdade — diferente de html2canvas, que rasteriza tudo em imagem.
//
// O CSS de impressão vive em index.css (#pdf-export-root). Elementos que só
// fazem sentido na tela (campo de envio, spinners, os próprios botões) devem
// ser marcados com data-pdf-hide — eles são removidos do clone.
// ─────────────────────────────────────────────────────────────

const ROOT_ID = 'pdf-export-root'
const BODY_CLASS = 'exportando-pdf'

export interface ExportPdfOptions {
  /** Título do documento (ex.: 'Falar sobre — Cliente X'). */
  title: string
  /** Linha de contexto abaixo do título (ex.: período, modelo). */
  subtitle?: string
}

export function exportNodeToPdf(node: HTMLElement | null, opts: ExportPdfOptions): void {
  if (!node) return
  // Sobra de uma exportação anterior que não limpou (impressão cancelada).
  document.getElementById(ROOT_ID)?.remove()

  const root = document.createElement('div')
  root.id = ROOT_ID

  const header = document.createElement('header')
  header.className = 'pdf-export-header'
  const h1 = document.createElement('h1')
  h1.textContent = opts.title
  header.appendChild(h1)
  if (opts.subtitle) {
    const sub = document.createElement('p')
    sub.textContent = opts.subtitle
    header.appendChild(sub)
  }
  const stamp = document.createElement('p')
  stamp.textContent = `Exportado em ${new Date().toLocaleString('pt-BR')}`
  header.appendChild(stamp)
  root.appendChild(header)

  const clone = node.cloneNode(true) as HTMLElement
  clone.querySelectorAll('[data-pdf-hide]').forEach((el) => el.remove())
  root.appendChild(clone)

  document.body.appendChild(root)
  document.body.classList.add(BODY_CLASS)

  // O título da janela vira o nome sugerido do arquivo no diálogo de impressão.
  const originalTitle = document.title
  document.title = opts.title

  let done = false
  const cleanup = (): void => {
    if (done) return
    done = true
    document.body.classList.remove(BODY_CLASS)
    document.title = originalTitle
    root.remove()
    window.removeEventListener('afterprint', cleanup)
  }

  window.addEventListener('afterprint', cleanup)
  window.print()
  // Rede de segurança: nem todo navegador dispara afterprint de forma confiável.
  // window.print() bloqueia até o diálogo fechar, então o timer só corre depois.
  window.setTimeout(cleanup, 1000)
}
